import { Badge } from '@givebutter/primitives/badge';
import { Box } from '@givebutter/primitives/box';
import { useCurrentLetter } from './useCurrentLetter';
import * as Iframe from 'components/iframe';
import { useAppState } from 'customHooks/useAppState';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const LetterPreview = () => {
    const { apiUrl } = useAppState();
    const { accountId } = useCurrentAccount();
    const { data: letter } = useCurrentLetter();

    return (
        <Box className={'relative px-6 py-4'}>
            <Badge className="absolute left-4 top-4">Preview</Badge>
            <Iframe.Root
                className={'min-h-[85vh]'}
                src={`${apiUrl}/dashboard/accounts/${accountId}/messages/${letter?.id}/preview#toolbar=0`}
            />
        </Box>
    );
};

export { LetterPreview };
